import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} width={33} height={32} fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M22.428 13a1 1 0 110 2h-12a1 1 0 110-2h12zM25.428 9a1 1 0 010 2h-18a1 1 0 110-2h18zM25.428 17a1 1 0 010 2h-18a1 1 0 110-2h18zM20.83 21a1 1 0 110 2h-8.802a1 1 0 110-2h8.801z" fill="#000" /></svg>;
}
export default SvgComponent;